import { makeVar } from '@apollo/client'

// To cache filtered date value
export type DateFilterValue = Date | null | undefined
export const filteredDateValueVar = makeVar<Record<string, DateFilterValue>>({})

export function getFilteredDateValue(colId: string): DateFilterValue {
  const filteredDateValueMapping = filteredDateValueVar()
  return filteredDateValueMapping[colId] ?? null
}

export function setFilteredDateValue(colId: string, date: any) {
  const filteredDateValueMapping = filteredDateValueVar()
  filteredDateValueVar({ ...filteredDateValueMapping, [colId]: date })
}

export function clearFilteredDateValues(colId: string) {
  const current = filteredDateValueVar()
  const { [colId]: _, ...rest } = current
  filteredDateValueVar(rest)
}

// To cache filtered date options
export const filteredDateGroupOptionsVar = makeVar<{ [colId: string]: any[] }>({})

export function getFilteredDateGroupOptions(colId: string) {
  const filteredDateGroupOptionsMapping = filteredDateGroupOptionsVar()
  return filteredDateGroupOptionsMapping[colId] ?? []
}

export function setFilteredDateGroupOptions(colId: string, options: any[]) {
  const filteredDateGroupOptionsMapping = filteredDateGroupOptionsVar()
  filteredDateGroupOptionsVar({ ...filteredDateGroupOptionsMapping, [colId]: options })
}

export function clearFilteredDateGroupOptions(colId: string) {
  const current = filteredDateGroupOptionsVar()
  const { [colId]: _, ...rest } = current
  filteredDateGroupOptionsVar(rest)
}
